"use strict";

angular.module('PatientApp').factory('NavService', function ($rootScope, resize, OverlayService, VuexStore) {
  var service = {
    open: function open() {
      VuexStore.dispatch('openNav');
    },
    close: function close() {
      VuexStore.dispatch('closeNav');
    },
    toggle: function toggle() {
      VuexStore.dispatch('toggleNav');
    },
    isNavOpen: function isNavOpen() {
      return VuexStore.state.AppStore.isNavOpen;
    }
  }; // We could run into an issue where positioning of the layout
  // is incorrect if we are on a desktop view with the nav open
  // and someone resizes the browser wider. We will listen for that
  // resize event on root to give us the trigger to close 

  $rootScope.$on('resize', function () {
    service.close();
  });
  return service;
});